import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";

export interface IGetAccommodationUnitType {
  id?: number;
  start_date?: string;
  end_date?: string;
  with_availability?: boolean;
}

export interface IPostAccommodationUnitType {
  title: string;
  category_id: number;
  base_occupancy: number;
  max_occupancy: number;
}

export interface IPutAccommodationUnitType {
  id: number;
  title: string;
  category_id: number;
  base_occupancy: number;
  max_occupancy: number;
  amenity_ids?: number[];
}

// GET Accommodation Unit Types
export async function GetAccommodationUnitTypes(params: IGetAccommodationUnitType, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/type"), params, useGlobalLoader);
}

// POST Accommodation Unit Types
export async function PostAccommodationUnitType(params: IPostAccommodationUnitType, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/type"), params, useGlobalLoader);
}
// PUT Accommodation Unit Types
export async function PutAccommodationUnitType(params: IPutAccommodationUnitType, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/type"), params, useGlobalLoader);
}

export interface IUnitTypeImage {
  id: number;
  unit_type_id: number;
  position: number;
  source: string;
  path: string;
  width: number;
  height: number;
}

export interface IGetAccommodationUnitTypeImage {
  id?: number;
}

export interface IDeleteAccommodationUnitTypeImage {
  id: number;
}

// GET Accommodation Unit Type Images
export async function GetAccommodationUnitTypeImages(params: IGetAccommodationUnitTypeImage, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/type/image"), params, useGlobalLoader);
}

// POST Accommodation Unit Type Images
export async function PostAccommodationUnitTypeImage(params: FormData, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/type/image"), params, useGlobalLoader);
}

// DELETE Accommodation Unit Type Images
export async function DeleteAccommodationUnitTypeImage(
  params: IDeleteAccommodationUnitTypeImage,
  useGlobalLoader: boolean,
) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/type/image"), params, useGlobalLoader);
}
